/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { ProductsAutoBulkImportContext } from '../contexts/ProductsAutoBulkImportContext';
import 'react-csv-importer/dist/index.css';
import Breadcrumbs from '../../../modules/navigation/components/Breadcrumbs';
import ProductAutoBulkcsvImport from '../components/ProductsAutoBulkcsvImport';

const ProductsAutoBulkcsvPartnerImportPage: React.FunctionComponent = () => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const apiPartner = queryParams.get('api_partner');

  const { machineSerial } = useParams<Record<string, string>>();
  const { setFailedRecords, setPassedRecords } = React.useContext(ProductsAutoBulkImportContext);

  React.useEffect(() => {
    setFailedRecords([]);
    setPassedRecords([]);
  }, []);

  const links = [
    {
      onClick: () => history.push(`/autobulk/machines/products`),
      text: 'AutoBulk Products',
    },
    {
      onClick: () => null,
      text: `Api Partner Bulk Import (Machine: ${machineSerial})`,
    },
  ];

  return (
    <>
      <Grid justifyContent="space-between" container spacing={3}>
        <Grid item>
          <Breadcrumbs links={links} />
        </Grid>
      </Grid>
      <br />
      <ProductAutoBulkcsvImport apiPartner={apiPartner} machineSerialNumber={machineSerial} />
    </>
  );
};

export default ProductsAutoBulkcsvPartnerImportPage;
